import ChipBuilder from './components/ChipBuilder';

function App() {
  return (
    <div className="App">
      <ChipBuilder />
    </div>
  );
}

export default App;
